// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"9051e12e","143":"afcf8962","424":"ecb063aa","494":"608c532f","533":"d1e3c96e","651":"8f703e60","690":"4d62ec0b","852":"f3622f83","940":"b2f6613a"}[chunkId] + ".chunk.js";
};